module.exports = {
	"description": "Card block component",
	"methods": []
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/react-docgen-loader!./src/Card/CardBlock.js
// module id = 1545
// module chunks = 0